import { render, staticRenderFns } from "./projectSelectTagDialog.vue?vue&type=template&id=fe24d35e"
import script from "./projectSelectTagDialog.vue?vue&type=script&lang=js"
export * from "./projectSelectTagDialog.vue?vue&type=script&lang=js"
import style0 from "./projectSelectTagDialog.vue?vue&type=style&index=0&id=fe24d35e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports